import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";

const PRODUCT_KEYS = [
  { key: "general", value: "general" },
  { key: "push", value: "push" },
  { key: "pull", value: "pull" },
];

const ProductSelector = ({
  selected,
  hasFreeTrial,
  isActivePull,
  isActivePush,
  isAdmin,
}) => {
  const navigateToSection = (product) => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        product,
        category: "",
      },
    });
  };

  const { t } = useTranslation("coaching-portal");
  const filteredProducts = PRODUCT_KEYS.filter((product) => {
    if (
      product.value === "pull" &&
      !(isActivePull || hasFreeTrial || isAdmin)
    ) {
      return false;
    }
    if (product.value === "push" && !(isActivePush || isAdmin)) {
      return false;
    }
    return true;
  });

  return (
    <div className="product-selector">
      {filteredProducts.map(({ key, value }, idx) => {
        return (
          <button
            data-button-type={selected === value ? "outline" : "secondary"}
            key={idx}
            onClick={() => navigateToSection(value)}
          >
            {t(`productSelector.${key}`)}
          </button>
        );
      })}
    </div>
  );
};

export default ProductSelector;
